import { Component, OnInit } from '@angular/core';
import {MainService} from "../../services/main.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  constructor(private mService:MainService,private route: ActivatedRoute,
      private router: Router) { }



  isNews:boolean;
  isNotice:boolean;
  isEvent:boolean;

  news:any={"news":""};
  event:any={"EventTitle":"",
  						"EventDate":{
  							"date":""
  						}
							};
  notice:any={"NoticeTitle":""};

  url:string = "";
  // pageUrl:any;

  ngOnInit() {
  	// this.pageUrl = this.route.snapshot.paramMap.get('id');
  	// this.mService.getNews(this.pageUrl).subscribe((result:any)=>{
   //    this.news = result;
   //  })
    

   console.log(this.router.url);

   if(this.router.isActive("/news",false)){
    this.mService.scrollToTop(500);
   	this.isNews = true;
  	this.route.params.subscribe( params => {
      this.mService.getNews(params.id).subscribe((resultt:any)=>{
        this.news = resultt;
      })
    });
   }

   if (this.router.isActive("/event",false)) {
    this.mService.scrollToTop(500);
   	this.isEvent = true;
   	this.route.params.subscribe( params => {
      this.mService.getEvent(params.id).subscribe((resultt:any)=>{
        this.event = resultt;
        console.log(this.event);
      })
    });
   }

   if (this.router.isActive("/notice",false)) {
    this.mService.scrollToTop(500);
   	this.isNotice = true;
   	this.route.params.subscribe( params => {
      this.mService.getNotice(params.id).subscribe((resultt:any)=>{
        this.notice = resultt;
        console.log(this.notice);
      })
    });
   }


  }

}



// WEBPACK FOOTER //
// ./src/app/components/news/news.component.ts